import { TxStatus } from '@orionprotocol/sdk';
import { ethers } from 'ethers';

export const txOnFailCallbacks = new Map<string, (status?: TxStatus) => void>();
export const txOnSuccessCallbacks = new Map<
  string,
  (txReceipt: ethers.TransactionReceipt) => void
>();
export const txOnChainCallbacks = new Map<string, () => void>();
export const txOnSentCallbacks = new Map<
  string,
  (txResponse: ethers.TransactionResponse) => void
>();
export const txOnErrorCallbacks = new Map<string, (error: Error) => void>();
export const txOnFinalCallbacks = new Map<string, () => void>();
